/* @ngInject */
export default class PartnerAppsService {
    constructor(HPConfig, $q, AuthenticationFactory, SingleSignOnFactory, FundingRequestDatastore, UiDisplayFactory, KBYGFactory) {
        this.$q = $q;
        this.HPConfig = HPConfig;
        this.UiDisplayFactory = UiDisplayFactory;
        this.AuthenticationFactory = AuthenticationFactory;
        this.FundingRequestDatastore = FundingRequestDatastore;
        this.SingleSignOnFactory = SingleSignOnFactory;
        this.KBYGFactory = KBYGFactory;
    }

    getBenjiLink() {
        const contractorType = this.UiDisplayFactory.getDisplayRules().isBenjiOnlyUser ? 0 : 1;
        return `${this.HPConfig.benjiFinancingLink}?ct=${contractorType}`;
    }

    getProPitchLink() {
        let proPitchLink = '';
        const primaryInfo = this.FundingRequestDatastore.getPrimaryInformation();

        proPitchLink = `${this.HPConfig.proPitchLink}/#/login?bt=${this.AuthenticationFactory.getAuthenticationData().access_token}`;
        if (primaryInfo && (primaryInfo.PreQualID || primaryInfo.FundingRequestId)) { // If ApplicationDetail is open, load Primary Information
            if (primaryInfo.PreQualID) { // Check if a KBYG/Lead AppDetail is open.
                proPitchLink += `&kbyg=${primaryInfo.ProposaltoolSecureId}`;
            } else {
                proPitchLink += `&fundingRequestId=${primaryInfo.FundingRequestSecureId}`;
            }
        }

        return proPitchLink;
    }

    getHeroCalcLink() {
        let heroCalcLink = '';

        heroCalcLink = `${this.HPConfig.heroCalcLink}?token=${this.AuthenticationFactory.getAuthenticationData().access_token}`;

        return heroCalcLink;
    }

    getReportLink(destination) {
        return this.$q((resolve) => {
            this.SingleSignOnFactory.getAuthorization().then((result) => {
                let reportLink = `${result.sfdc_community_url}/secur/frontdoor.jsp`;
                reportLink += `?sid=${result.access_token}`;
                reportLink += `&retURL=${result.sfdc_community_url}/s/${destination}`;
                return resolve(reportLink);
            });
        });
    }

    getOneAppLink(contractorLocationId) {
        return this.$q((resolve) => {
            this.KBYGFactory.getOneAppLink(contractorLocationId).then((result) => {
                return resolve(result.data.Data.Url);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/angular/PartnerAppsFactory.js